import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-posting-media-modal',
  templateUrl: './posting-media-modal.component.html',
  styleUrls: ['./posting-media-modal.component.scss']
})
export class PostingMediaModalComponent implements OnInit {

  @Input() is_show_post_media_modal;
  @Input() is_show_post_media_modal_data;
  @Output() resetPostMediaModal = new EventEmitter();
  constructor() {
    // No Code
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  media_type: any;
  ngOnInit(): void {
    // console.log(this.is_show_post_media_modal_data[0].obj)
    this.media_type = (this.is_show_post_media_modal_data[0].obj.type.split('/'));
    this.media_type = this.media_type[0];

  }

  hideModal(): void {
    this.is_show_post_media_modal = false;
    this.resetPostMediaModal.emit(false);
  }
}
